import { useContext } from 'react'
import { AppStateContext } from '../state/AppProvider'

export const useOperatingUnits = (): string[] => {
  const appState = useContext(AppStateContext)
  return appState?.state.lookups.ous ?? []
}
